import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import OutImage from 'images/sports/common/out.png';
import InImage from 'images/sports/common/in.png';
import clsx from 'clsx';
import {
  Contents,
  ContentsHeader,
  Player,
  Row,
  List,
  ListItem,
  BattingSlot,
  Empty
} from './styled';

const BaseballMatchLineupBatterTable = observer(({ data }) => {
  const ulHeight = useMemo(() => {
    if (data.length > 0) {
      return 36 * data.list.length;
    } else {
      return 0;
    }
  }, [data]);

  return (
    <Contents>
      <ContentsHeader>
        <BattingSlot>타순</BattingSlot>
        <Player>선수명</Player>
        <Row>타율</Row>
        <Row>포지션</Row>
      </ContentsHeader>
      <List style={{ height: ulHeight }}>
        {data.list.length > 0 ? (
          data.list.map((item, idx) => {
            const {
              name,
              battingSlot,
              battingAverage,
              position,
              slotIndex,
              startingMember
            } = item;

            const dataLength = data.list.length;
            const nextIdx = idx + 1;
            let activeIcon = false;
            let lastIn = false;

            if (
              dataLength > nextIdx &&
              battingSlot === data.list[idx + 1].battingSlot
            ) {
              activeIcon = true;
            }

            if (
              idx > 0 &&
              dataLength > nextIdx &&
              battingSlot === data.list[idx - 1].battingSlot
            ) {
              activeIcon = true;

              if (slotIndex < data.list[idx - 1].slotIndex) {
                lastIn = true;
              }
            }

            return (
              <ListItem
                key={`${item.id}${idx}`}
                className={clsx(data.length === idx + 1 && 'noneBorder')}
              >
                {/* <span>{slotIndex}</span>
                  <span>{String(startingMember)}</span> */}
                <BattingSlot>
                  {battingSlot}
                  {activeIcon && (
                    <img src={lastIn ? OutImage : InImage} alt="out" />
                  )}
                </BattingSlot>
                <Player>{name}</Player>
                <Row>{battingAverage}</Row>
                <Row>{position}</Row>
              </ListItem>
            );
          })
        ) : (
          <Empty>
            <div>투수 정보가 없습니다.</div>
          </Empty>
        )}
      </List>
    </Contents>
  );
});

export default BaseballMatchLineupBatterTable;
